import { IStoreData, IStoreDataV3, Store } from '@df/catalog/store/store';
import { StoreResource } from '@df/catalog/store/store.resource';
import { GMTDateToUK } from '@df/util/fn/uk-date';
declare module '@df/catalog/store/store' {
    interface IStoreDataV1 {
        region?: string;
        first_pickup_date?: string;
        images?: string[];
    }
    interface IStoreDataV3 {
        store_features?: number | number[];
        owner_name?: string;
    }
}
export class LocalStore<T extends IStoreData = IStoreData> extends Store<T> {
    get storeFeatures(): number[] | undefined {
        const storeFeatures = (<IStoreDataV3>this.data).store_features;
        if (typeof storeFeatures === 'number') {
            return [storeFeatures];
        }
        return storeFeatures;
    }
    /**
     * If store is open now
     */
    override get isOpenNow(): boolean {
        const hours = this.todayOpeningHours;
        if (!hours) {
            return false;
        }
        const date = new Date();
        GMTDateToUK(date);
        const h = (date.getUTCHours() + '').padStart(2, '0') + ':' + (date.getUTCMinutes() + '').padStart(2, '0');
        return hours?.status === 1 && hours.open <= h && hours.close > h;
    }

    override get isOpenToday(): boolean {
        const hours = this.todayOpeningHours;
        return (hours && !!(hours.open && hours.open !== 'CLOSED')) || false;
    }
}

StoreResource.instance = LocalStore;
